/* import __COLOCATED_TEMPLATE__ from './project-create-find-freelancer.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-posting-create-find-freelancer';

class PostingCreateFindFreelancer extends Component {
  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
      'LSG-l-grid justify-center',
    );
  }

  get className() {
    return CLASS_NAME;
  }

  /**
   * @param {Event} e
   */
  @action
  handleSubmit(e) {
    e.preventDefault();
  }
}

export default PostingCreateFindFreelancer;
